import React from "react"

import ColumnText from "./ColumnText"
import { Element, Image } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import {
  PrismicBlogPostDataBodyHero,
  PrismicBlogPostDataType,
  PrismicStructuredTextType,
  PrismicImageType,
} from "types/__generated__/gatsby-graphql"

type Body = Maybe<
  Maybe<Pick<PrismicBlogPostDataBodyHero, "id"> & { primary: Primary }>
>[]
type OgImage = Maybe<Pick<PrismicImageType, "alt" | "url">>
type PostSubTitle = Maybe<
  Pick<PrismicStructuredTextType, "html" | "richText" | "text">
>
type PostTitle = Maybe<
  Pick<PrismicStructuredTextType, "richText" | "html" | "text">
>
type Primary = Maybe<{ post_title: PostTitle; post_subtitle: PostSubTitle }>
type RecentPostData = Maybe<
  Pick<PrismicBlogPostDataType, "publish_date"> & {
    body: Body
    og_image: OgImage
  }
>

type QueriedPostData = Maybe<RecentPostData>

interface OwnProps {
  data: QueriedPostData
  url: Maybe<string>
}

export type ColumnProps = OwnProps

const Column: React.FC<ColumnProps> = ({
  data,
  url,
}): React.ReactElement | null => {
  const content = data?.body?.[0]?.primary

  if (!content || !url) return null
  const { height, width } = data?.dimensions || {}

  return (
    <Element
      display="flex"
      flexDirection="column"
      gridColumn={"span 1"}
      m={["0 auto 45px", "0 0 75px", "0 0 75px"]}
      maxWidth={["450px", "450px", "none"]}
    >
      <Element
        display="block"
        justifyContent="flex-start"
        mb={["20px", "50px"]}
        width="100%"
      >
        <Element width="100%">
          <Image
            aspectRatio={`${width} / ${height}`}
            display="block"
            imageData={data?.og_image}
            width={["450px", "339px", "417px", "357px"]}
          />
        </Element>
      </Element>
      <ColumnText data={content} url={url} />
    </Element>
  )
}

export default Column
